// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__zM5kS","error":"InputSecondary_error__pbmrm","disabled":"InputSecondary_disabled__3ElzS"};